export default __webpack_public_path__ + "static/media/lc.46ec9f4c.svg";